import React, {useState} from 'react';
import {DeleteOutlined} from '@ant-design/icons';
import {Button, Popconfirm} from 'antd';
import {deleteD365UnfoundProject} from "../../api/d365Api";

const RemoveUnfoundProjectButton = ({ id, email, onCompleted }) => {
  const [loading, setLoading] = useState(false);

  const remove = async () => {
    try {
      setLoading(true)
      const response = await deleteD365UnfoundProject(id, email);
      onCompleted(response, "removed");
    } catch (e) {
      console.error(`Could not remove unfound project`);
    } finally {
      setLoading(false);
      onCompleted(null,"")
    }
  };

  return (
    <Popconfirm
      title={`Are you sure you want to remove this unfound project (this cannot be undone)?`}
      onConfirm={remove}
      okText="Yes"
      cancelText="No"
    >
      <Button icon={<DeleteOutlined />} loading={loading}>Remove</Button>
    </Popconfirm>
  );
};

export { RemoveUnfoundProjectButton };